import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/authSlice';
import bdAddressReducer from '../features/bdAddressSlice';
import attachmentsReducer from '../features/attachmentsSlice';
import websiteReducer from '../features/websiteSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  bdAddress: bdAddressReducer,
  attachments: attachmentsReducer,
  website: websiteReducer,
});

export default rootReducer;
